export default [
    {
        path: '/',
        component: () => import('@/layouts/DefaultLayout.vue'),
        children: [
            {
                path: '',
                name: 'index',
                component: () => import('@/pages/Index.vue')
            },
            {
                path: '/:slug',
                name: 'campaign',
                component: () => import('@/pages/Campaign'),
                props: true
            },
            {
                path: '*',
                component: () => import('@/pages/Error404')
            }
        ]
    }

]
